<template>
	<div
		class="envelope-section-live"
		ref="confettiCanvas"
	>
		<!--<ReactCanvasConfetti refConfetti={getInstance} class="confetti" />-->
		<div
			class="price-background"
			ref="priceBackground"
		>
			<i
				class="fas fa-bahai explotion"
				title="Deals"
			></i>
			<i
				class="fas fa-bahai explotion-cirlce"
				title="Deals"
			></i>
		</div>
		<div
			class="envelope-container"
			ref="listRef"
			v-if="envelopesToShow"
		>
			<div
				v-for="(envelopes, index) in envelopesToShow"
				:key="index"
				class="envelope-area"
			>
				<img
					src="@static/img/SaturnLogoAnim.svg"
					v-if="index == cardWaiting"
					class="card-waiting"
				/>
				<div
					class="envelope outside move-fast"
					:class="{ 'flip-small': envelopes.count }"
				>
					<div
						class="card"
						@click="selectCard(envelopes, index)"
					>
						<div class="front face">
							<div class="card-name name">
								{{ envelopes.winnerLive ? winnerInfo(envelopes.winnerLive).name.split(',')[1] : '' }}
							</div>
							<div class="card-name lastname">
								{{ envelopes.winnerLive ? winnerInfo(envelopes.winnerLive).name.split(',')[0] : '' }}
							</div>
							<div class="dollar-sign top">$</div>
							<div class="dollar-sign bottom">$</div>
							<img src="@static/img/raffle/logoRafle.png" />
							<div class="card-money">
								{{ formatPrice(envelopes.price) }}
							</div>
						</div>
						<div class="back face">
							<div :class="index % 2 ? 'inside-container red' : 'inside-container blue'">
								<div class="inside-background">
									<img :src="index % 2 ? 'dist/img/raffle/red.png' : 'dist/img/raffle/blue.png'" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			class="pagination hide"
			ref="pageRef"
		>
			<div
				v-for="(pages, index) in pagesAmount"
				:key="pages"
				:class="{
					active: index + 1 == page,
					pages: true,
					green: pageAvailableToSelect(),
					red: !pageAvailableToSelect(),
				}"
				@click="changePage(index + 1)"
			></div>
		</div>
	</div>
</template>

<script>
	import confetti from 'canvas-confetti';

	export default {
		name: 'LiveCarrousel',
		emits: ['update:page'],
		props: [
			'animateReorder',
			'envelopes',
			'activePlayer',
			'players',
			'updateActiveUser',
			'updateMoney',
			'money',
			'page',
			'winnerInfo',
			'goToWinners',
			'lastWinners',
			'startGame',
			'isGamePlayer',
		],
		data() {
			return {
				moneyReveal: new Audio('/static/audio/money_reveal.mp3'),
				whoosh: new Audio('/static/audio/whoosh.mp3'),
				wheel: new Audio('/static/audio/wheel.mp3'),
				explotion: new Audio('/static/audio/explotion.mp3'),
				explotion2: new Audio('/static/audio/explotion2.mp3'),
				roll: new Audio('/static/audio/roll.mp3'),
				tada: new Audio('/static/audio/tada.mp3'),
				fuzz: new Audio('/static/audio/fuzz.mp3'),
				whooshCards: new Audio('/static/audio/whoosh-cards.mp3'),
				cardShuffle: new Audio('/static/audio/card-shuffle.mp3'),
				snowTime: 0,
				prideTime: 0,
				playing: null,
				stopOnNextEnvelope: null,
				startEnvelopeAnimation: null,
				envelopesToShow: [],
				cardAnimated: 0,
				pagesAmount: [],
				perPages: 25,
				intervalId: null,
				pageChanged: true,
				cardWaiting: null,
			};
		},
		computed: {},
		created() {
			this.$watch(
				() => this.startGame,
				newValue => {
					if (newValue) {
						this.pagesAmount = [...new Array(this.amountOfPages())];
						if (localStorage.getItem('rafflePage')) {
							if (localStorage.getItem('rafflePage') <= this.pagesAmount) {
								this.$emit('update:page', parseInt(localStorage.getItem('rafflePage')));
							} else {
								this.$emit('update:page', 1);
							}
						} else {
							this.$emit('update:page', 1);
						}
					}
				},
				{ deep: true },
			);

			this.$watch(
				() => this.page,
				newValue => {
					if (newValue) {
						//localStorage.setItem('raffleCards', JSON.stringify(this.envelopes))
						localStorage.setItem('rafflePage', this.page);
						this.envelopesToShow = this.envelopes.slice((this.page - 1) * this.perPages, this.page * this.perPages);
					}
				},
				{ deep: true },
			);

			this.$watch(
				() => this.envelopesToShow,
				(newValue, oldValue) => {
					if (newValue && this.pageChanged) {
						this.pageChanged = false;
						if (this.cardShuffle) {
							setTimeout(() => {
								if (!this.isGamePlayer) {
									this.cardShuffle.play().then(() => {
										setTimeout(() => {
											this.cardShuffle.pause();
											this.cardShuffle.currentTime = 0;
										}, 5000);
									});
								}
							}, 250);
						}

						this.$refs.pageRef.classList.remove('hide');
						this.envelopesToShow.forEach((e, index) => {
							setTimeout(() => {
								let position = this.$refs.listRef.childNodes[index].getBoundingClientRect();
								this.$refs.listRef.childNodes[index].lastChild.style.top = '-' + (position.top + 200) + 'px';
								this.$refs.listRef.childNodes[index].lastChild.style.left = '50%';
								setTimeout(() => {
									this.$refs.listRef.childNodes[index].classList.remove('fade-shrink');
									this.$refs.listRef.childNodes[index].lastChild.classList.remove('move-fast');
									this.$refs.listRef.childNodes[index].lastChild.firstChild.classList.remove('hide');
									this.$refs.listRef.childNodes[index].lastChild.style.top = '2px';
									this.$refs.listRef.childNodes[index].lastChild.style.left = '13px';
									if (index + 1 == this.envelopesToShow.length) {
										this.activePlayer.updating = this.activePlayer ? false : null;
									}
								}, 100);
							}, 50 * index);
						});
					}
				},
				{ deep: true },
			);

			this.$watch(
				() => this.goToWinners,
				newValue => {
					if (newValue == false) {
						this.playing = true;
					}
				},
				{ deep: true },
			);

			this.MeetingHubBus.on('cashBashReadySelectCardOK', this.cashBashReadySelectCardOK);
			this.MeetingHubBus.on('cashBashReadySelectPage', this.cashBashReadySelectPage);
		},
		beforeUnmount() {
			this.MeetingHubBus.off('cashBashReadySelectCardOK', this.cashBashReadySelectCardOK);
			this.MeetingHubBus.off('cashBashReadySelectPage', this.cashBashReadySelectPage);
		},
		methods: {
			//confetti-animations
			pride() {
				if (!this.isGamePlayer) {
					var end = Date.now() + 3000;
					(function pride() {
						confetti({
							particleCount: 3,
							angle: 60,
							spread: 55,
							origin: { x: 0 },
							colors: ['#bb0000', '#ffffff'],
						});
						confetti({
							particleCount: 3,
							angle: 120,
							spread: 55,
							origin: { x: 1 },
							colors: ['#bb0000', '#ffffff'],
						});

						if (Date.now() < end) {
							requestAnimationFrame(pride);
						}
					})();
				}
			},

			fire(x, y, angle = 90) {
				if (!this.isGamePlayer) {
					var end = Date.now() + 1;
					(function fire() {
						confetti({
							particleCount: Math.floor(200 * 0.25),
							spread: 26,
							startVelocity: 55,
							origin: { x: x, y: y },
							angle,
						});
						confetti({
							particleCount: Math.floor(200 * 0.28),
							spread: 126,
							startVelocity: 55,
							origin: { x: x, y: y },
							angle,
						});
						confetti({
							particleCount: Math.floor(200 * 0.45),
							spread: 76,
							startVelocity: 55,
							origin: { x: x, y: y },
							angle,
						});
						confetti({
							particleCount: Math.floor(200 * 0.15),
							spread: 86,
							startVelocity: 55,
							origin: { x: x, y: y },
							angle,
						});
						confetti({
							particleCount: Math.floor(200 * 0.2),
							spread: 60,
							origin: { x: x, y: y },
							angle,
						});
						confetti({
							particleCount: Math.floor(200 * 0.35),
							spread: 100,
							decay: 0.91,
							scalar: 0.8,
							origin: { x: x, y: y },
							angle,
						});
						confetti({
							particleCount: Math.floor(200 * 0.1),
							spread: 120,
							startVelocity: 25,
							decay: 0.92,
							scalar: 1.2,
							origin: { x: x, y: y },
							angle,
						});
						confetti({
							particleCount: Math.floor(200 * 0.1),
							spread: 120,
							startVelocity: 45,
							origin: { x: x, y: y },
							angle,
						});

						if (Date.now() < end) {
							requestAnimationFrame(fire);
						}
					})();
				}
			},

			formatPrice(price) {
				return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			},
			selectCard(envelopes, index) {
				if (
					this.activePlayer &&
					this.activePlayer.envelopes > 0 &&
					!this.activePlayer.updating &&
					!envelopes.count &&
					this.activePlayer.userCode == this.isGamePlayer
				) {
					//do it after saving the database and response true
					this.activePlayer.updating = true;
					this.cardWaiting = index;
					this.$meetingHub.gameSelectCard(JSON.stringify({ envelopes, index }));
				}
			},
			cashBashReadySelectCardOK(cardObject) {
				let card = JSON.parse(cardObject);
				this.cardWaiting = null;
				this.envelopeAnimation(card.envelopes, card.index);
			},
			changePage(page) {
				if (page != this.page) {
					this.$meetingHub.gameChangePage(page);
				}
			},
			cashBashReadySelectPage(page) {
				if (page != this.page) {
					if (this.activePlayer && this.activePlayer.envelopes > 0 && !this.activePlayer.updating) {
						this.activePlayer.updating = true;
						this.envelopesToShow.forEach((e, index) => {
							this.$refs.listRef.childNodes[index].classList.add('fade-shrink');
						});
						setTimeout(() => {
							this.envelopesToShow.forEach((e, index) => {
								this.$refs.listRef.childNodes[index].lastChild.classList.add('move-fast');
							});
							setTimeout(() => {
								this.envelopesToShow = [];
								this.pageChanged = true;
								this.$emit('update:page', page);
							}, 500);
						}, 300);
					}
				}
			},

			amountOfPages() {
				return this.envelopes ? Math.ceil(this.envelopes.length / this.perPages) : 0;
			},
			pageAvailableToSelect() {
				return !this.envelopes.slice(this.perPages * (this.page - 1), this.perPages * this.page - 1).some(e => e.count == false);
			},

			envelopeAnimation(envelope, index) {
				this.startEnvelopeAnimation = true;
				let activeEnvelopeIndex = index;
				let activeEnvelope = envelope;

				if (activeEnvelope.priceLevel == 1) {
					this.$refs.priceBackground.style.display = 'flex';
					setTimeout(() => {
						let position = this.$refs.listRef.childNodes[activeEnvelopeIndex].getBoundingClientRect();
						let screen = this.$refs.confettiCanvas.getBoundingClientRect();
						this.$refs.listRef.childNodes[activeEnvelopeIndex].lastChild.style.top = screen.height / 2 - (position.top - screen.top) + 'px';
						this.$refs.listRef.childNodes[activeEnvelopeIndex].lastChild.style.left = screen.width / 2 - (position.left - screen.left) + 'px';
						this.$refs.listRef.childNodes[activeEnvelopeIndex].lastChild.classList.add('envelope-grow');
						if (!this.isGamePlayer) {
							setTimeout(() => {
								this.roll.play().then(() => {
									setTimeout(() => {
										this.roll.pause();
										this.roll.currentTime = 0;
									}, 3000);
								});
							}, 200);
						}
						this.$refs.priceBackground.classList.add('show');
						this.$refs.priceBackground.firstChild.classList.add('blow');
						this.$refs.priceBackground.lastChild.classList.add('blow-c');
					}, 1);
					setTimeout(() => {
						setTimeout(() => {
							this.$refs.listRef.childNodes[activeEnvelopeIndex].lastChild.classList.add('flip');
							if (!this.isGamePlayer) {
								setTimeout(() => {
									this.whoosh.play().then(() => {
										setTimeout(() => {
											this.whoosh.pause();
											this.whoosh.currentTime = 0;
										}, 1000);
									});
								}, 300);
								setTimeout(() => {
									this.tada.play().then(() => {
										setTimeout(() => {
											this.tada.pause();
											this.tada.currentTime = 0;
										}, 1300);
									});
								}, 500);
							}
						}, 500);

						setTimeout(() => {
							this.fire(0.3, 0.7);
							if (!this.isGamePlayer) {
								this.explotion.play().then(() => {
									setTimeout(() => {
										this.explotion.pause();
										this.explotion.currentTime = 0;
									}, 2700);
								});
							}
							this.fire(0.5, 0.7);
							this.fire(0.7, 0.7);
							this.pride();
							if (!this.isGamePlayer) {
								this.fuzz.play().then(() => {
									setTimeout(() => {
										this.fuzz.pause();
										this.fuzz.currentTime = 0;
									}, 4200);
								});
							}
							setTimeout(() => {
								this.fire(0.3, 0.7);
								this.fire(0.5, 0.7);
								this.fire(0.7, 0.7);
							}, 2000);

							setTimeout(() => {
								this.$refs.confettiCanvas.firstChild.classList.add('hide');
								this.$refs.priceBackground.classList.add('hide');
								setTimeout(() => {
									this.$refs.listRef.childNodes[activeEnvelopeIndex].lastChild.classList.add('show-price');
									this.$refs.listRef.childNodes[activeEnvelopeIndex].lastChild.classList.remove('envelope-grow');
									let position = this.$refs.listRef.childNodes[activeEnvelopeIndex].getBoundingClientRect();
									this.$refs.listRef.childNodes[activeEnvelopeIndex].lastChild.style.top = '2px';
									this.$refs.listRef.childNodes[activeEnvelopeIndex].lastChild.style.left = '13px';
									setTimeout(() => {
										//this.stopAnimation()

										setTimeout(() => {
											this.$refs.priceBackground.style.display = 'none';
											this.startEnvelopeAnimation = false;
											this.envelopesToShow = this.envelopesToShow.map(eS =>
												eS.id == activeEnvelope.id
													? {
															...eS,
															winnerLive: this.activePlayer.id,
															count: true,
														}
													: { ...eS },
											);

											this.$refs.priceBackground.firstChild.classList.remove('blow');
											this.$refs.priceBackground.lastChild.classList.remove('blow-c');

											this.activePlayer.envelopes = this.activePlayer.envelopes - 1;
											this.activePlayer.amount = this.activePlayer.amount + activeEnvelope.price;
											let indexEnvelopes = this.envelopes.findIndex(env => env.id == activeEnvelope.id);
											this.envelopes[indexEnvelopes].winnerLive = this.activePlayer.id;
											this.envelopes[indexEnvelopes].count = true;
										}, 1000);
										this.$refs.confettiCanvas.firstChild.classList.remove('hide');
										this.$refs.priceBackground.classList.remove('show');
									}, 700);
								}, 900);
							}, 4000);
						}, 900);
					}, 2500);
				} else if (activeEnvelope.priceLevel == 2) {
					this.moneyReveal.pause();
					this.moneyReveal.currentTime = 0;
					setTimeout(() => {
						setTimeout(() => {
							this.$refs.listRef.childNodes[activeEnvelopeIndex].lastChild.classList.add('flip-small');
							if (!this.isGamePlayer) {
								setTimeout(() => {
									this.moneyReveal.play().then(() => {
										setTimeout(() => {
											this.moneyReveal.pause();
											this.moneyReveal.currentTime = 0;
										}, 1000);
									});
									this.whoosh.play().then(() => {
										setTimeout(() => {
											this.whoosh.pause();
											this.whoosh.currentTime = 0;
										}, 800);
									});
								}, 1);
							}
							setTimeout(() => {
								this.envelopesToShow = this.envelopesToShow.map(eS =>
									eS.id == activeEnvelope.id ? { ...eS, winnerLive: this.activePlayer.id, count: true } : { ...eS },
								);
								this.startEnvelopeAnimation = false;
								this.activePlayer.envelopes = this.activePlayer.envelopes - 1;
								this.activePlayer.amount = this.activePlayer.amount + activeEnvelope.price;
								let indexEnvelopes = this.envelopes.findIndex(env => env.id == activeEnvelope.id);
								this.envelopes[indexEnvelopes].winnerLive = this.activePlayer.id;
								this.envelopes[indexEnvelopes].count = true;
							}, 1000);
						}, 300);
					}, 1);
				}
			},
		},
	};
</script>
<style>
	.card-waiting {
		position: absolute;
		z-index: 999;
		width: 148px;
		transform: translate(-46%, -47%);
		left: 50%;
		top: 50%;
	}
</style>
